import { Injectable } from '@angular/core'
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http'
import { Observable, catchError, throwError, NEVER } from 'rxjs'
import { AuthLoginService } from '../services/auth-login.service'

@Injectable()
export class AuthCheckInterceptor implements HttpInterceptor {
  constructor(private loginService: AuthLoginService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const req = request.clone({
      withCredentials: true,
    })

    return next.handle(req)
      .pipe(
        catchError(error => {
          if (error.status === 401) {
            this.loginService.login()
            return NEVER
          } else {
            // eslint-disable-next-line no-console
            console.error(error)
            return throwError(() => error)
          }
        }),
      )
  }
}
